const SHARE_SESSION_KEY_PREFIX = 'streamrtv-shareSession-';
/**
 * Persists which sessions were created through the /share deep link, so a
 * page reload can re-apply their capture policy (screen-only, never
 * camera/microphone) before any capture starts.
 */
export class ShareLinkStore {
    hasShareSession(streamId) {
        try {
            return (localStorage.getItem(SHARE_SESSION_KEY_PREFIX + streamId) !==
                null);
        }
        catch {
            return false;
        }
    }
    setShareSession(streamId) {
        try {
            localStorage.setItem(SHARE_SESSION_KEY_PREFIX + streamId, '1');
        }
        catch {
            // localStorage may be unavailable in some environments
        }
    }
    clearShareSession(streamId) {
        try {
            localStorage.removeItem(SHARE_SESSION_KEY_PREFIX + streamId);
        }
        catch {
            // localStorage may be unavailable in some environments
        }
    }
}
